import { notification } from 'antd';
import listingFileUploadTypes from '../action-types/listingFileUpload';

const initialState = {
  uploadingFile: false,
  uploadingFileError: null,
  uploadingFileSuccess: null,
};

const createMessageSuccess = () => {
  notification.success({
    message: 'File uploaded',
  });
};

const createMessageError = (error) => {
  notification.error({
    message: 'Error uploading file',
    description: error,
  });
};

const listingFileUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case listingFileUploadTypes.UPLOAD_PUPPY_FILE_REQUEST: {
      return {
        ...state,
        uploadingFile: true,
        uploadingFileError: null,
        uploadingFileSuccess: false,
      };
    }
    case listingFileUploadTypes.UPLOAD_PUPPY_FILE_SUCCESS: {
      createMessageSuccess();
      return {
        ...state,
        uploadingFile: false,
        uploadingFileError: null,
        uploadingFileSuccess: true,
      };
    }
    case listingFileUploadTypes.UPLOAD_PUPPY_FILE_ERROR: {
      const { error } = action;
      createMessageError(error);
      return {
        ...state,
        uploadingFile: false,
        uploadingFileError: error,
        uploadingFileSuccess: false,
      };
    }
    default:
      return state;
  }
};

export default listingFileUploadReducer;
